<template>
  <v-app class="da-app" style="background: #0A0A0B !important;">
    <!-- Header -->
    <v-app-bar
      app
      dark
      color="#111113"
      elevation="0"
      height="60"
      class="da-admin-appbar"
      style="border-bottom: 1px solid rgba(255,255,255,0.07);"
    >
      <!-- Logo -->
      <div class="d-flex align-center ml-2">
        <div class="da-logo-icon mr-2">
          <span class="da-logo-e">E</span>
        </div>
        <div>
          <div class="da-logo-text">ElevMent</div>
          <div class="da-logo-sub">Admin</div>
        </div>
      </div>

      <v-spacer />

      <!-- Ações do Header -->
      <div class="d-flex align-center mr-2">
        <v-btn
          text
          class="da-header-btn"
          @click="goToSettings"
        >
          <v-icon left small>mdi-cog-outline</v-icon>
          Configurações
        </v-btn>
        <v-btn
          text
          class="da-header-btn ml-1"
          @click="logout"
        >
          <v-icon left small>mdi-logout</v-icon>
          Sair
        </v-btn>
      </div>
    </v-app-bar>

    <!-- Conteúdo Principal -->
    <v-main class="da-main">
      <v-container fluid class="pa-6" style="max-width: 1280px; margin: 0 auto;">

        <!-- Chip Modo Visualização -->
        <div class="text-center mb-5">
          <v-chip
            class="da-view-chip px-5"
            small
          >
            <v-icon left small color="#4FC3F7">mdi-eye-outline</v-icon>
            <span style="color: #4FC3F7; font-weight: 600; font-size: 13px;">Modo Visualização</span>
          </v-chip>
        </div>

        <!-- Título Principal -->
        <div class="text-center mb-2">
          <h1 class="da-title">Selecione um Gestor</h1>
          <p class="da-subtitle mt-2">
            Escolha qual gestor você deseja visualizar. Você terá acesso somente leitura.
          </p>
        </div>

        <!-- Barra de Busca -->
        <v-row class="mt-5 mb-6 da-search-row">
          <v-col cols="12">
            <v-text-field
              v-model="searchQuery"
              placeholder="Buscar por nome, departamento ou e-mail..."
              outlined
              dense
              prepend-inner-icon="mdi-magnify"
              clearable
              hide-details
              class="da-search"
            />
          </v-col>
        </v-row>

        <!-- Cards de Estatísticas -->
        <v-row class="mb-6">
          <!-- Gestores -->
          <v-col cols="12" sm="6" md="3">
            <v-card dark class="da-stat-card text-center pa-5">
              <v-icon class="da-stat-icon mb-3">mdi-account-group-outline</v-icon>
              <div class="da-stat-number">{{ stats.totalManagers }}</div>
              <div class="da-stat-label mt-1">GESTORES</div>
            </v-card>
          </v-col>

          <!-- Colaboradores -->
          <v-col cols="12" sm="6" md="3">
            <v-card dark class="da-stat-card text-center pa-5">
              <v-icon class="da-stat-icon mb-3">mdi-pulse</v-icon>
              <div class="da-stat-number">{{ stats.totalEmployees }}</div>
              <div class="da-stat-label mt-1">COLABORADORES</div>
            </v-card>
          </v-col>

          <!-- Departamentos -->
          <v-col cols="12" sm="6" md="3">
            <v-card dark class="da-stat-card text-center pa-5">
              <v-icon class="da-stat-icon mb-3">mdi-clipboard-text-outline</v-icon>
              <div class="da-stat-number">{{ stats.totalDepartments }}</div>
              <div class="da-stat-label mt-1">DEPARTAMENTOS</div>
            </v-card>
          </v-col>

          <!-- Ativos -->
          <v-col cols="12" sm="6" md="3">
            <v-card dark class="da-stat-card text-center pa-5">
              <v-icon class="da-stat-icon da-stat-icon--teal mb-3">mdi-eye-outline</v-icon>
              <div class="da-stat-number da-stat-number--teal">{{ stats.activePercentage }}%</div>
              <div class="da-stat-label mt-1">ATIVOS</div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Lista de Gestores -->
        <v-row>
          <v-col
            v-for="manager in managers"
            :key="manager.id"
            cols="12"
            md="6"
          >
            <v-card
              dark
              class="da-manager-card"
              @click="selectManager(manager)"
            >
              <v-card-text class="pa-4">
                <div class="d-flex align-center">
                  <!-- Avatar -->
                  <v-avatar
                    :color="getAvatarColor(manager.name)"
                    size="46"
                    class="mr-4 flex-shrink-0"
                  >
                    <span class="white--text font-weight-bold" style="font-size: 15px;">
                      {{ getInitials(manager.name) }}
                    </span>
                  </v-avatar>

                  <!-- Informações -->
                  <div class="flex-grow-1 min-width-0">
                    <div class="da-manager-name">{{ manager.name }}</div>
                    <div class="da-manager-email mb-2">{{ manager.email }}</div>
                    <div class="d-flex align-center flex-wrap" style="gap: 6px;">
                      <v-chip
                        v-if="manager.department"
                        x-small
                        class="da-tag"
                      >{{ manager.department }}</v-chip>
                      <v-chip
                        v-for="squad in (manager.squads || [])"
                        :key="squad"
                        x-small
                        class="da-tag"
                      >{{ squad }}</v-chip>
                    </div>
                  </div>

                  <!-- Seta -->
                  <v-icon class="da-arrow ml-3" small>mdi-arrow-right</v-icon>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Estado Vazio -->
        <v-row v-if="!loading && managers.length === 0" justify="center">
          <v-col cols="12" md="6" class="text-center py-12">
            <v-icon size="56" color="rgba(255,255,255,0.15)">mdi-account-search-outline</v-icon>
            <p class="da-empty-title mt-4">Nenhum gestor encontrado</p>
            <p class="da-empty-sub">
              {{ searchQuery ? 'Tente ajustar sua busca' : 'Ainda não há gestores cadastrados' }}
            </p>
          </v-col>
        </v-row>

        <!-- Loading -->
        <v-overlay :value="loading" opacity="0.8">
          <v-progress-circular
            indeterminate
            size="56"
            width="3"
            color="#FF771C"
          />
        </v-overlay>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { TenantService } from '@/services'

export default {
  name: 'DashboardTenantAdmin',

  data: () => ({
    loading: false,
    searchQuery: '',
    
    // Estatísticas
    stats: {
      totalManagers: 0,
      totalEmployees: 0,
      totalDepartments: 0,
      activePercentage: 0
    },

    // Lista de gestores
    managers: [],
  }),

  watch: {
    // Buscar no backend quando usuário digitar
    searchQuery: {
      handler() {
        this.loadManagersDebounced()
      }
    }
  },

  async mounted() {
    await this.loadDashboardData()
    
    // Criar versão debounced da busca
    this.loadManagersDebounced = this.debounce(this.loadManagers, 500)
  },

  methods: {
    async loadDashboardData() {
      this.loading = true
      try {
        await Promise.all([
          this.loadStats(),
          this.loadManagers()
        ])
      } catch (error) {
        console.error('Erro ao carregar dados do dashboard:', error)
        this.$store.dispatch('showSnackbar', {
          text: 'Erro ao carregar dados. Tente novamente.',
          color: 'error'
        })
      } finally {
        this.loading = false
      }
    },

    async loadStats() {
      try {
        const response = await TenantService.getTenantStats()
        this.stats = response.data
      } catch (error) {
        console.error('Erro ao carregar estatísticas:', error)
        this.$store.dispatch('showSnackbar', {
          text: 'Erro ao carregar estatísticas.',
          color: 'error'
        })
      }
    },

    async loadManagers() {
      try {
        // Preparar parâmetros de busca
        const params = {}
        if (this.searchQuery && this.searchQuery.trim()) {
          params.search = this.searchQuery.trim()
        }

        const response = await TenantService.getManagers(params)
        
        // Backend retorna { total: X, items: [...] }
        this.managers = response.data.items || []
        
        console.log(`✅ ${this.managers.length} gestores carregados`)
      } catch (error) {
        console.error('Erro ao carregar gestores:', error)
        this.$store.dispatch('showSnackbar', {
          text: 'Erro ao carregar lista de gestores.',
          color: 'error'
        })
      }
    },

    debounce(func, wait) {
      let timeout
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout)
          func.apply(this, args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
      }
    },

    selectManager(manager) {
      // Navegar para dashboard do gestor em modo visualização
      this.$router.push({
        path: `/manager/${manager.id}`,
        query: { 
          viewOnly: 'true',
          managerName: manager.name,
          managerRole: manager.department || 'Gestor'
        }
      })
    },

    getInitials(name) {
      if (!name) return '?'
      const parts = name.split(' ')
      if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
      }
      return name.substring(0, 2).toUpperCase()
    },

    getAvatarColor(name) {
      const colors = [
        'success',
        'blue',
        'orange',
        'purple',
        'teal',
        'pink',
        'indigo'
      ]
      const index = name.charCodeAt(0) % colors.length
      return colors[index]
    },

    goToSettings() {
      // Navegar para configurações do admin (SEM sidebar)
      console.log('Navegando para /admin-settings')
      console.log('User:', localStorage.getItem('user'))
      console.log('Token:', localStorage.getItem('firebaseToken'))
      this.$router.push('/admin-settings').catch(err => {
        console.error('Erro ao navegar:', err)
      })
    },

    logout() {
      // Remove todos os dados de autenticação do localStorage
      localStorage.removeItem('firebaseToken')
      localStorage.removeItem('user')
      localStorage.removeItem('tenantId')
      localStorage.removeItem('backendToken')
      
      // Redireciona para a tela de login
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
/* ============================================================
   DARK THEME — DASHBOARD TENANT ADMIN
   Paleta: #0A0A0B background, #111113 cards, #FF771C laranja
============================================================ */

.da-app {
  background: #0A0A0B !important;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* Força fundo escuro no nível raiz do Vuetify */
.da-app.v-application {
  background: #0A0A0B !important;
}

.da-app >>> .v-application--wrap {
  background: #0A0A0B !important;
}

.da-main {
  background: #0A0A0B !important;
}

.da-main >>> .v-main__wrap {
  background: #0A0A0B !important;
}

/* --- LOGO --- */
.da-logo-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #FF771C;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.da-logo-e {
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 800;
  font-family: 'Inter', sans-serif;
  line-height: 1;
}

.da-logo-text {
  font-size: 15px;
  font-weight: 700;
  color: #FFFFFF;
  letter-spacing: -0.01em;
  line-height: 1.1;
}

.da-logo-sub {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
  font-weight: 500;
}

/* --- HEADER BUTTONS --- */
.da-header-btn {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: rgba(255, 255, 255, 0.65) !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
}

.da-header-btn:hover {
  color: #FFFFFF !important;
}

/* --- CHIP MODO VISUALIZAÇÃO --- */
.da-view-chip {
  background: rgba(79, 195, 247, 0.1) !important;
  border: 1px solid rgba(79, 195, 247, 0.25) !important;
  border-radius: 100px !important;
}

/* --- TÍTULO --- */
.da-title {
  font-size: 28px;
  font-weight: 700;
  color: #FFFFFF;
  letter-spacing: -0.02em;
}

.da-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}

.da-search-row {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

/* --- SEARCH --- */
.da-search >>> .v-input__slot {
  background: #111113 !important;
  border-radius: 10px !important;
}

.da-search >>> fieldset {
  border-color: rgba(255, 255, 255, 0.1) !important;
  border-radius: 10px !important;
}

.da-search >>> .v-input--is-focused fieldset {
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.da-search >>> input {
  color: #FFFFFF !important;
  font-size: 14px !important;
}

.da-search >>> input::placeholder {
  color: rgba(255, 255, 255, 0.3) !important;
}

.da-search >>> .v-icon {
  color: rgba(255, 255, 255, 0.35) !important;
}

/* --- STAT CARDS --- */
.da-stat-card {
  background: #111113 !important;
  border: 1px solid rgba(255, 255, 255, 0.07) !important;
  border-radius: 12px !important;
  box-shadow: none !important;
}

.da-stat-card.theme--dark {
  background: #111113 !important;
}

.da-stat-card >>> .v-card__text,
.da-stat-card >>> .v-card__title,
.da-stat-card >>> .v-card__subtitle {
  background: transparent !important;
}

.da-stat-icon {
  font-size: 22px !important;
  color: rgba(255, 255, 255, 0.45) !important;
}

.da-stat-icon--teal {
  color: #4DB6AC !important;
}

.da-stat-number {
  font-size: 32px;
  font-weight: 700;
  color: #FFFFFF;
  letter-spacing: -0.03em;
  line-height: 1;
}

.da-stat-number--teal {
  color: #4DB6AC !important;
}

.da-stat-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: rgba(255, 255, 255, 0.35);
}

/* --- MANAGER CARDS --- */
.da-manager-card {
  background: #111113 !important;
  border: 1px solid rgba(255, 255, 255, 0.07) !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.da-manager-card.theme--dark {
  background: #111113 !important;
}

.da-manager-card >>> .v-card__text {
  background: transparent !important;
}

.da-manager-card:hover {
  background: #1A1A1E !important;
  border-color: rgba(255, 255, 255, 0.15) !important;
}

.da-manager-card:hover.theme--dark {
  background: #1A1A1E !important;
}

.da-manager-name {
  font-size: 15px;
  font-weight: 600;
  color: #FFFFFF;
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.da-manager-email {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.45);
}

.da-tag {
  background: rgba(255, 255, 255, 0.06) !important;
  color: rgba(255, 255, 255, 0.65) !important;
  border-radius: 4px !important;
  font-size: 11px !important;
  font-weight: 500 !important;
  height: 20px !important;
  padding: 0 7px !important;
}

.da-arrow {
  color: rgba(255, 255, 255, 0.25) !important;
  transition: color 0.15s;
}

.da-manager-card:hover .da-arrow {
  color: rgba(255, 255, 255, 0.65) !important;
}

/* --- EMPTY STATE --- */
.da-empty-title {
  font-size: 17px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}

.da-empty-sub {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.3);
  margin: 4px 0 0;
}

.min-width-0 {
  min-width: 0;
}
</style>

<!-- Override global: força header e fundo escuro sem depender do tema Vuetify -->
<style>
.da-admin-appbar.v-app-bar,
.da-admin-appbar.theme--light.v-app-bar,
.da-admin-appbar.theme--dark.v-app-bar,
.da-app .v-app-bar,
.da-app .v-toolbar {
  background-color: #111113 !important;
  background: #111113 !important;
}

.da-admin-appbar .v-toolbar__content,
.da-app .v-toolbar__content {
  background: #111113 !important;
}

/* Garante que o wrapper raiz do da-app fique escuro */
.da-app .v-application--wrap {
  background: #0A0A0B !important;
  min-height: 100vh;
}
</style>
